export const AchievementCardSkeleton = () => (
  <div className='border border-gray-200 rounded-2xl overflow-hidden flex flex-col bg-white animate-pulse'>
    <div className='flex items-start gap-2 p-2.5'>
      <div className='size-20 shrink-0 rounded-xl bg-gray-200' />
      <div className='flex flex-col gap-1.5 flex-1 pt-0.5'>
        <div className='h-4 w-3/4 bg-gray-200 rounded' />
        <div className='h-3 w-full bg-gray-200 rounded' />
        <div className='h-3 w-2/3 bg-gray-200 rounded' />
      </div>
    </div>
    <div className='h-11 px-3 flex items-center'>
      <div className='h-5 w-full bg-gray-200 rounded-full' />
    </div>
  </div>
);
